import { PlusOutlined } from '@ant-design/icons'
import { Breadcrumb, Button, Space, Typography } from 'antd'
import { Link } from 'react-router-dom'

import { ClusterNameLink } from '@/components/common/ClusterNameLink'

const { Title, Text } = Typography

export function PriceDetailHeader({
  label,
  clusterId,
  groupName,
  onAdd,
}: {
  label: string
  clusterId: string
  groupName: string
  onAdd: () => void
}) {
  return (
    <>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[
          { title: <Link to="/user-groups">User Groups</Link> },
          {
            title: <Link to={`/user-groups/${groupName}`}>{groupName}</Link>,
          },
          { title: label },
        ]}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 24,
        }}
      >
        <div>
          <Title level={4} style={{ margin: 0 }}>
            {label}
          </Title>
          <Space size="middle" style={{ marginTop: 8 }}>
            <Text type="secondary">
              Cluster: <ClusterNameLink clusterId={clusterId} />
            </Text>
            <Text type="secondary">Group: {groupName}</Text>
          </Space>
        </div>
        <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
          Add Price
        </Button>
      </div>
    </>
  )
}
